module.exports = __webpack_public_path__ + "img/image-19.d95c924f.jpg";